import React from 'react';
import styles from '../AiDialog.module.css';

export function QuickPromptStyles({ predefinedPrompts, activePrompt, onSelectPrompt }) {
  return (
    <div className={styles.quickPromptsRoot}>
      <p className={styles.quickPromptsHeading}>Quick prompt styles</p>
      <div className={styles.chipRow}>
        {predefinedPrompts.map((p) => (
          <button
            key={p.id}
            type='button'
            onClick={() => onSelectPrompt(p.text)}
            className={`${styles.chip} ${activePrompt === p.text ? styles.chipActive : ''}`}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
